/**
 * Convert http:// URLs to https:// to avoid mixed content warnings.
 * ML API returns thumbnails with http:// but mlstatic.com supports https.
 */
export function secureUrl(url: string | null | undefined): string {
  if (!url) return '';
  return url.replace(/^http:\/\//i, 'https://');
}
